import React from "react";
import { useStore } from "../stores/store";

export default function Alert() {
  const { alertMessage } = useStore();
  return (
    <>
      {alertMessage !== "" && (
        <div className="toast toast-end z-[10000]">
          <div className="alert alert-success text-white">
            <span className="loading loading-spinner loading-sm"></span>
            <span>{alertMessage}</span>
          </div>
        </div>
      )}
    </>
  );
}
